<template>
    <v-main>
       <aresGPT/>
       <navbar title="Ares - Main menu" :home="true" :accolist="true" type="main"/>
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';
    import aresGPT from '@/components/syst/openai/aresGPT.vue';

    export default {        
        components: {
            navbar,
            aresGPT,
        },
        data() {
            return {
                title: "",
                loading: true,
            }
        },
        methods: {         
        },
    }
</script>

<style scoped>
</style>
